/**
 * VELQUE — shared phone number validation.
 *
 * Rule: exactly 10 numeric digits.
 * Reused across BusinessSetup, Appointments create, Vendor modal — and mirrored
 * in the backend (server.py / vendors.py) so any API call is validated too.
 */

export const PHONE_ERROR = "Please enter a valid 10-digit mobile number.";
export const PHONE_REGEX = /^[0-9]{10}$/;

/** Return true if `v` matches exactly 10 digits. */
export function isValidPhone(v) {
  return PHONE_REGEX.test(String(v ?? "").trim());
}

/**
 * True if the value is acceptable *for form submission*.
 * - When `required` is false, empty is allowed.
 * - When any characters are present, they must satisfy `isValidPhone`.
 */
export function isSubmittablePhone(v, { required = true } = {}) {
  const s = String(v ?? "").trim();
  if (!s) return !required;
  return isValidPhone(s);
}

/** Coerce arbitrary keystrokes into up-to-10 digits. Safe for controlled inputs. */
export function sanitizePhoneInput(v) {
  return String(v ?? "").replace(/\D/g, "").slice(0, 10);
}
